<template>
	<div>
		<label-required :label="'User Name'" :condition="user.user_name" />
		<input type="text" v-model="user.user_name" autocomplete="new-password">

		<label>Last Login</label>
		<input type="text" v-model="user.last_login" disabled />

		<label v-if="user.user_id">New Password</label>
		<label-required v-else label="Password" :condition="user.new_password"/>
		<input type="password" v-model="user.new_password" autocomplete="new-password">

		<label>Last Password Change</label>
		<input type="text" v-model="user.last_password_change" disabled />
		
		<template v-if="!isProfile">
			<label-required label="User Type" :condition="user.user_type_id"/>
			<select v-model="user.user_type_id" @change="user.user_type_code = userTypeCode(user.user_type_id)">
				<option value="">Select...</option>
				<option v-for="(userType, index) in localUserTypes" :value="userType.user_type_id">{{ userType.description }}</option>
			</select>

			<label v-if="userTypeCode(user.user_type_id) == 'POS_CASHIER'">PIN</label>
			<input v-if="userTypeCode(user.user_type_id) == 'POS_CASHIER'" type="text" v-model="user.pin">
			<div v-if="userTypeCode(user.user_type_id) && (userTypeCode(user.user_type_id).indexOf('MANAGER') > -1)">
				<label>Manager Code</label>
				<input type="text" v-model="user.pos_manager_code">
			</div>

			<div class="checkbox-group" style="margin: 0.5em 0 0 0;">
				<div v-if="getUser.administrator_flag && userTypeCode(user.user_type_id) && userTypeCode(user.user_type_id).indexOf('MANAGER') > -1" class="component-with-tool-tip v-spaced">
					<span :class="['pointer', 'far', user.administrator_flag ? 'fa-check-square' : 'fa-square']" @click="user.administrator_flag = !user.administrator_flag"></span>
					<label>Store administrator</label>
					<tool-tip left='-14' content='Store administrators can manage other users, update product prices and have additional permissions.'/>
				</div>
				<div class="component-with-tool-tip v-spaced">
					<span :class="['pointer', 'far', user.force_password_change ? 'fa-check-square' : 'fa-square']" @click="user.force_password_change = !user.force_password_change"></span>
					<label>Force password change</label>
					<tool-tip left='-12' content='When checked, this will force the user to change their password the next time they log in.'/>
				</div>
				<div class="component-with-tool-tip v-spaced">
					<span :class="['pointer', 'far', user.inactive ? 'fa-check-square' : 'fa-square']" @click="user.inactive = !user.inactive"></span>
					<label>Deactivate</label>
					<tool-tip left='-6' content='When checked, this will deactitvate the user and prevent them from logging in again.'/>
				</div>
			</div>
			<div v-if="getAdministratorFlag" style="margin: 4.5em 0 0 0;">
				<h2>Client</h2>
				<select v-model="user.client_id">
					<option value="">Select...</option>
					<option v-for="(client, index) in clients" :value="client.client_id">{{ client.company_name }} [{{ client.client_id}}]</option>
				</select>
			</div>
		</template>
	</div>
</template>
<script>
import LabelRequired from '@/components/LabelRequired.vue'
import ToolTip from '@/components/ToolTip.vue'
export default {
	name: 'user-inputs',
	components: {
		'label-required': LabelRequired,
		'tool-tip': ToolTip
	},
	props: {
		user: {
			type: [Object],
			required: true,
		},
		userTypes: {
			type: [Array],
			required: false,
			default() {
         	   return []
        	}		
		}
	},
	data() {
		return {
			clientId: this.getClientId,
			loading: false,
			message: '',
			saving: false,
			messageStatus: '',
			messageTimeout: 0,
			isProfile: false,
			managerUserTypes: 0,
			localUserTypes: [],
			clients: []
		}
	},
	created() {
		if (this.$route.path.indexOf('customers') > -1 || this.$route.path.indexOf('members') > -1) {
			this.managerUserTypes = 0
		} else {
			this.managerUserTypes = 1
		}
		if (this.$route.path.indexOf('profile') > -1) {
			this.isProfile = true
		} else {
			this.isProfile = false
			if (this.userTypes.length == 0) {
				this.getUserTypes()
			} else {
				this.localUserTypes = this.userTypes
			}
			if (this.getAdministratorFlag && this.clients.length == 0) {
				this.getListClients()
			}
		}
	},
	methods: {
		getListClients() {
			this.apiCall({ destination: 'get_list_clients_full_list' }).then(obj => {
				this.clients = obj.clients
			}).catch(err => {
				console.log(err)
			})
		},
        getUserTypes() {
            this.apiCall({ destination: 'get_list_user_types', data: { manager_flag: this.managerUserTypes } }).then(obj => {
                this.localUserTypes = obj.user_types
            }).catch(err => {
                console.log(err);
            })
        },
		userTypeCode(userTypeId) {
			if (this.isProfile) {
				return this.getUser.user_type_code
			}
			if (userTypeId == 'store_administrator') {
				return 'MANAGER'
			}
			for (let i = 0; i < this.userTypes.length; i++) {
				if (this.userTypes[i].user_type_id == userTypeId) {
					return this.userTypes[i].user_type_code
				}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
